import React, { createContext, useContext, useState } from "react";
import { themeOptions } from "../Styles/theme";

export const ThemeContext = createContext()

 export const ThemeContextProvider =({children})=>{
    const defaultval=JSON.parse(localStorage.getItem('theme')) || themeOptions[0].value
    const [theme,settheme]=useState(defaultval)
    const values ={
        theme,
        settheme,
        defaultval
    }
    return (<ThemeContext.Provider value={values}>{children}</ThemeContext.Provider>)
}
export const useTheme=()=>useContext(ThemeContext)